import {NgModule} from '@angular/core';
import {IonicModule} from 'ionic-angular';
import {PrismLogoModule} from '../../../../shared/components/prism-logo/prism-logo.module';

import {ContentHeaderComponent} from './index';

/**
 * Module for the ContentHeeaderComponent
 */
@NgModule({
  declarations: [ContentHeaderComponent],
  exports: [ContentHeaderComponent],
  imports: [
    IonicModule,
    PrismLogoModule,
  ],
  providers: [],
})
export class ContentHeaderModule {
}



// WEBPACK FOOTER //
// ./src/app/content/shared/components/content-header/content-header.module.ts